import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { PasskeyDetailsPage } from '@egw/features-auth'

export const SettingsPasskeyDetailsPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.settings.title')} />
      <PasskeyDetailsPage />
    </Layout>
  )
}
